import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ANALYTICS_CONSENT_EVENT, CONSENT_KEY, syncAnalyticsConsent, trackPageView } from 'utils/analytics';

export function Analytics() {
  const { pathname } = useLocation();
  useEffect(() => {
    const storage = (event: StorageEvent) => {
      if (event.key === CONSENT_KEY || event.key === null) syncAnalyticsConsent();
    };
    syncAnalyticsConsent();
    window.addEventListener('storage', storage);
    window.addEventListener('focus', syncAnalyticsConsent);
    window.addEventListener('pageshow', syncAnalyticsConsent);

    return () => {
      window.removeEventListener('storage', storage);
      window.removeEventListener('focus', syncAnalyticsConsent);
      window.removeEventListener('pageshow', syncAnalyticsConsent);
    };
  }, []);
  useEffect(() => {
    const track = () => trackPageView(pathname);
    track();
    window.addEventListener(ANALYTICS_CONSENT_EVENT, track);

    return () => window.removeEventListener(ANALYTICS_CONSENT_EVENT, track);
  }, [pathname]);

  return null;
}
